export default "__VITE_ASSET__85e3600f__"